<template>
	<div>
		<div id="confirmPart" class="background-white" style="height: auto; padding: 25px 0px 50px 0px; position: relative;
    max-width: 1270px;
    margin: 0 auto;">
			<div class="content_wrapper">
				<div class="headline">{{ $t('confirmTitle') }}</div>
				<div class="souhrn_statement">
					{{ $t('confirmDesc') }}
				</div>
				<div class="souhrn_list_wrapper">
					<div v-for="item in getRecordsToConfirm" :key="item.subscriberId"
							 class="list_item_wrapper">
						<img class="souhrn_item_icon" src="../assets/images/icons/phone_plne_pozadi.svg"/>
						<div class="souhrn_text_wrapper">
							<div class="souhrn_item_name">
								{{ item.alias !== null ? item.alias : item.msisdn }}
							</div>
							<div class="souhrn_item_tarif">
								{{ $t('confirmNewTariff') }} {{ item.newTariffDetail.tariffName }}
							</div>
						</div>
					</div>
					<!-- item end -->
				</div>
				<div class="info_wrapper" style="margin-left: 15px; margin-right: 15px;">
					<img class="info_icon" src="../assets/images/icons/circle_vykricnik.svg"/>
					<div class="info_text">
						{{ $t('confirmInfoText') }}
					</div>
				</div>
				<div class="btn_wrapper" style="padding-left: 15px; padding-right: 15px;">
					<button class="btn_app btn_transparent" v-on:click="backToMigrationSection()">{{ $t('confirmBackCta') }}</button>
					<button class="btn_app btn_magenta" v-on:click="confirmTariffs()">{{ $t('confirmContinueCta') }}</button>
				</div>
			</div>
		</div>

		<div id="resultPart" class="hide background-white d-block text-center" style="height: auto; padding: 50px 0px;">
			<div v-show="overlay">
				<b-spinner variant="primary" class="spinner-custom"></b-spinner>
				<div style="margin: 80px 0;">
					<p class="loading-title">{{ $t('sendingOrder') }}</p>
				</div>
			</div>
			<div v-show="!overlay" style="display: grid;">

				<div id="successPart" class="content_wrapper hide">
					<div class="main_ikona">
						<img src="../assets/images/icons/fajfjka_zelena.svg"/>
					</div>
					<div class="headline">{{ $t('modalContentOkTitle') }}</div>
					<div class="hotovo_statement">
						{{ $t('resultSuccessDesc') }}
					</div>
					<div class="hotovo_text">
						{{ $t('resultSuccessDesc2') }}
					</div>
					<div class="numbers_list">
						<div v-for="item in getSucessMsisdn()" :key="item.subscriberId">
							<div>{{ formatMsisdn(item.msisdn) }}</div>
						</div>
					</div>
					<div class="hotovo_statement">
						{{ $t('resultSuccessDesc3') }}
					</div>
					<div class="btn_wrapper" style="display: initial;">
						<button class="btn_app btn_magenta" v-on:click="returnBack('ok')">{{ $t('resultSuccessOk') }}</button>
					</div>
				</div>

				<div id="partiallyPart" class="content_wrapper hide">
					<div class="main_ikona">
						<img src="../assets/images/icons/castecne.svg"/>
					</div>
					<div class="headline">{{ $t('partially') }}</div>
					<div class="castecne_hotovo_text">
						{{ $t('resultPartiallyDesc') }}
						<br><br>
						{{ $t('changeTariffSuccessDesc') }}
					</div>
					<div v-for="item in getSucessMsisdn()" :key="item.subscriberId"
							 class="castecne_hotovo_text">
						{{ formatMsisdn(item.msisdn) }}
					</div>
					<div class="castecne_hotovo_text">
						{{ $t('resultPartiallyDesc2') }}
						<br><br>
					</div>
					<div class="castecne_hotovo_text">
						{{ $t('changeTariffFailedDesc') }}
					</div>
					<div v-for="item in getErrorMsisdn()" :key="item.subscriberId">
						<div class="castecne_hotovo_text">
							{{ formatMsisdn(item.msisdn) }}
						</div>
						<div v-if="item.errorMessages !== null"
								 class="castecne_hotovo_text">
							{{ item.errorMessages[0] }}
						</div>
					</div>

					<div class="btn_wrapper" style="display: initial;">
						<button class="btn_app btn_magenta" v-on:click="returnBack('partially')">{{ $t('dashboardBackCta') }}</button>
					</div>
				</div>

				<div id="errorPart" class="content_wrapper hide">
					<div class="main_ikona">
						<img src="../assets/images/icons/ajeje.svg"/>
					</div>
					<div class="headline">{{ $t('modalContentErrorTitle') }}</div>
					<div class="inside_text_normal" v-html="$t('failedCommonMsg')">

					</div>
					<div class="btn_wrapper" style="display: initial;">
						<button class="btn_app btn_magenta" v-on:click="returnBack('failed')">{{ $t('dashboardBackCta') }}</button>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import BffAPI from "@/service/BffAPI";

export default {
	name: "ConfirmComponent.vue",
	methods: {
		sendCardEvent(id) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'migration_process',
				'tile_type': id
			});
		},
		returnBack(id) {
			this.sendCardEvent("click_confirm_back_with_result_"+id)
			this.$store.state.isMigrationDataLoaded = false
			this.$store.state.isBasicInfoDataError = false
			this.$store.state.basicInfoData = null
			this.$store.state.transformInfoData = []
			this.$store.state.confirmSimpleStatusInfo = null
			this.$store.state.resetMap = true
			this.$store.dispatch('GET_BASIC_INFO', this.$store.state.jwt)
			const migrationSection = document.querySelector('#migrationSection')
			migrationSection.classList.remove('hide')
			const confirmSection = document.querySelector('#confirmationSection')
			confirmSection.classList.add('hide')
			document.getElementById("topContainer").scrollIntoView()
		},
		backToMigrationSection() {
			this.sendCardEvent("click_confirm_back")
			const migrationSection = document.querySelector('#migrationSection')
			migrationSection.classList.remove('hide')
			const confirmSection = document.querySelector('#confirmationSection')
			confirmSection.classList.add('hide')
			document.getElementById("topContainer").scrollIntoView()
		},
		confirmTariffs() {
			this.sendCardEvent("click_confirm_all_next")

			const confirmPart = document.querySelector('#confirmPart')
			confirmPart.classList.add('hide')

			const resultPart = document.querySelector('#resultPart')
			resultPart.classList.remove('hide')

			document.getElementById("topContainer").scrollIntoView()

			const records = this.$store.state.transformInfoData.filter(it => "qualified" === it.qualificationResults[0].result
					&& "qualified" === it.qualificationResults[1].result && it.newTariffDetail !== null)
			let prepareBody = []
			records.forEach(item => {
				prepareBody.push({
					subscriberId: item.subscriberId,
					msisdn: this.formatMsisdnForBff(item.msisdn),
					tariffId: item.newTariffDetail.tariffId,
					validateOnly: false
				})
			})

			const body = {
				items: prepareBody
			}

			const successPart = document.querySelector('#successPart')
			successPart.classList.add('hide')
			const partiallyPart = document.querySelector('#partiallyPart')
			partiallyPart.classList.add('hide')
			const errorPart = document.querySelector('#errorPart')
			errorPart.classList.add('hide')

			this.$store.state.confirmStatusLoading = true
			BffAPI.confirmTariffs(this.$store.state.jwt, body).finally(() => this.showResult())
		},
		formatMsisdnForBff(value) {
			value = value.replace('+420', '')
			return value.replace(/\s/g, "")
		},
		showResult() {

			const success = this.$store.state.confirmSimpleStatusInfo.filter(it => it.responseStatus === 'SUBMITTED')
			const failed = this.$store.state.confirmSimpleStatusInfo.filter(it => it.responseStatus === 'FAILED')

			if (this.$store.state.confirmSimpleStatusInfo.length === success.length) {
				// vse ok
				const successPart = document.querySelector('#successPart')
				successPart.classList.remove('hide')
			} else if (success.length !== 0 && failed.length !== 0) {
				// cast ok a cast ne
				const partiallyPart = document.querySelector('#partiallyPart')
				partiallyPart.classList.remove('hide')
			} else {
				// ajeje
				const errorPart = document.querySelector('#errorPart')
				errorPart.classList.remove('hide')
			}
			this.$store.state.confirmStatusLoading = false
		},
		getSucessMsisdn() {
			if (this.$store.state.confirmSimpleStatusInfo != null) {
				return this.$store.state.confirmSimpleStatusInfo.filter(it => it.responseStatus === 'SUBMITTED')
			}
		},
		getErrorMsisdn() {
			if (this.$store.state.confirmSimpleStatusInfo != null) {
				return this.$store.state.confirmSimpleStatusInfo.filter(it => it.responseStatus === 'FAILED')
			}
		},
		formatMsisdn(value) {
			if (value !== undefined && value.startsWith('420')) {
				value = value.replace('420', '+420')
			} else if (value !== undefined && !value.startsWith('420')) {
				value = '+420' + value
			}
			value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
			return value
		}
	},
	computed: {
		overlay() {
			return this.$store.state.confirmStatusLoading
		},
		getRecordsToConfirm() {
			let posibleCount = []
			if (this.$store.state.isMigrationDataLoaded && this.$store.state.transformInfoData !== null) {
				posibleCount = this.$store.state.transformInfoData.filter(it => "qualified" === it.qualificationResults[0].result
						&& "qualified" === it.qualificationResults[1].result && it.newTariffDetail !== null)
			}
			return posibleCount
		}
	}
}
</script>

<style scoped>

.btn_wrapper {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	margin-top: 39px;
	place-self: center;
}

.btn_magenta {
	width: 234px;
}

.hotovo_text {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 250;
	font-size: 24px;
	line-height: 27px;
	align-items: center;
	text-align: center;
	color: #262626;
	max-width: 682px;
	place-self: center;
	padding-left: 16px;
	padding-right: 16px;
}

.numbers_list {
	display: grid;
	grid-template-columns: 1fr;
	padding-bottom: 27px;
}

.hotovo_statement, .numbers_list {
	font-family: "TeleNeoLocalBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 24px;
	line-height: 27px;
	text-align: center;
	color: #262626;
	max-width: 682px;
	place-self: center;
	padding-left: 16px;
	padding-right: 16px;
}

.headline {
	max-width: 682px;
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 48px;
	line-height: 55px;
	text-align: center;
	color: #262626;
	padding-bottom: 20px;
	padding-top: 30px;
	place-self: center;
	padding-left: 16px;
	padding-right: 16px;
}

.background-white {
	display: grid;
	grid-template-columns: 1fr;
	height: 894px;
}

.content_wrapper {
	width: fit-content;
	place-self: center;
	display: grid;
	grid-template-columns: 1fr;
}

.main_ikona {
	place-self: center;
}

.loading-title {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 30px;
	line-height: 28px;
	text-align: center;
	place-self: center;
}

.spinner-custom {
	color: #e20074 !important;
	margin-top: 10%;
	width: 3rem;
	height: 3rem;
	border-width: 2px;
}

.souhrn_list_wrapper {
	display: grid;
	grid-template-columns: 1fr;
}

.list_item_wrapper {
	display: grid;
	grid-template-columns: auto 1fr;
	place-self: center;
}

.souhrn_text_wrapper {
	display: grid;
	grid-template-columns: 1fr;
	place-self: center left;
	padding: 14px 16px 14px 0px;
	margin-left: 16px;
	border-bottom: 1px solid #EBEBEB;
	width: 256px;
}

.list_item_wrapper:last-child .souhrn_text_wrapper {
	border-bottom: none !important;
}

.souhrn_item_icon {
	width: 36px;
	place-self: center;
}

.souhrn_item_name {
	font-family: "TeleNeoLocalBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 24px;
	line-height: 27px;
	color: #262626;
}

.souhrn_item_tarif {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 18px;
	line-height: 21px;
	color: #262626;
}

.btn_wrapper {
	width: 100%;
	text-align: -webkit-center;
	margin-top: 25px;
	place-self: center;
}

.btn_magenta {
	width: 234px;
	place-self: center right;
}

.btn_transparent {
	background: transparent !important;
	color: #e20074 !important;
	border: 1px solid #e20074;
	width: 234px;
	place-self: center left;
}

.info_wrapper {
	margin-top: 25px;
	display: grid;
	grid-template-columns: auto 1fr;
	background: #FFF5E8;
	border-radius: 10px;
	padding: 34px 15px 34px 20px;
}

.info_icon {
	width: 24px;
	place-self: center start;
}

.info_text {
	place-self: center left;
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 21px;
	line-height: 20px;
	color: #262626;
	padding-left: 15px;
}

.hotovo_text {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 250;
	font-size: 24px;
	line-height: 27px;
	align-items: center;
	text-align: center;
	color: #262626;
	max-width: 682px;
	place-self: center;
	padding-left: 16px;
	padding-right: 16px;
}

.numbers_list {
	display: grid;
	grid-template-columns: 1fr;
	padding-bottom: 27px;
}

.souhrn_statement {
	font-family: "TeleNeoLocalMedium";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 500;
	font-size: 21px;
	line-height: 24px;
	letter-spacing: -0.3px;
	color: #262626;
	max-width: 682px;
	place-self: center;
	padding-left: 16px;
	padding-right: 16px;
	padding-bottom: 33px;
}

.headline {
	max-width: 682px;
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 48px;
	line-height: 55px;
	text-align: center;
	color: #262626;
	padding-bottom: 9px;
	place-self: center;
	padding-left: 16px;
	padding-right: 16px;
}

.background-white {
	display: grid;
	grid-template-columns: 1fr;
	height: 894px;
}

.content_wrapper {
	width: 100%;
	max-width: 664px;
	place-self: center;
	display: grid;
	grid-template-columns: 1fr;
}

.main_ikona {
	place-self: center;
}

@media only screen and (max-width: 770px) {
	.btn_wrapper {
		grid-template-columns: 1fr 234px;
		column-gap: 12px;
	}

	.btn_transparent {
		max-width: 234px;
		width: 100%;
	}

	.btn_wrapper {
		margin-top: 25px;
	}
}
</style>
